import Colors from './colors';

const genericFontStyles = {
  family: 'FuturaPT-Book',
  color: 'black',
  weight: 'normal',
};
export const Headline4 = {
  ...genericFontStyles,
  size: 24,
  height: 30,
  spacing: 0.2,
};

export const SearchText = {
  ...genericFontStyles,
  color: Colors.dustyGray,
  desktop: {
    size: 24,
    height: 30,
    weight: 500,
    spacing: 0.2,
  },
  mobile: {
    size: 16,
    height: 22,
  },
};

export const SuggestedText = {
  ...genericFontStyles,
  size: 12,
  height: 24,
  spacing: 3,
  weight: 500,
};

export const ImageMovieTitleText = {
  ...genericFontStyles,
  size: 14,
  height: 18,
  spacing: 0.1,
  weight: 500,
  desktop: {
    weight: 'normal',
  },
  mobile: {
    weight: 500,
  },
};

export const ImageMovieYearText = {
  ...ImageMovieTitleText,
  weight: 'normal',
  height: 22,
  color: Colors.dustyGray,
};

export const ButtonText = {
  ...genericFontStyles,
  size: 12,
  height: 24,
  spacing: 3,
  weight: 500,
  color: 'white',
};

export const NotificationText = {
  ...genericFontStyles,
  size: 16,
  height: 22,
  color: 'white',
};

export const InstructionText = {
  ...genericFontStyles,
  color: Colors.dustyGray,
  desktop: {
    size: 14,
    height: 22,
    weight: 'normal',
  },
  mobile: {
    size: 12,
    height: 14,
    weight: 500,
    spacing: 0.1,
  },
};

export const loadingText = {
  ...genericFontStyles,
  size: 16,
  height: 22,
};

export const moviePlaceholderText = {
  ...genericFontStyles,
  size: 28,
  height: 31,
  spacing: 1,
  weight: 300,
};

export const FormTitleText = {
  ...genericFontStyles,
  weight: 500,
  desktop: {
    size: 24,
    height: 30,
    spacing: 0.2,
  },
  mobile: {
    size: 12,
    height: 24,
    spacing: 3,
  },
  color: 'white',
};

export const FormPlaceholderText = {
  ...genericFontStyles,
  size: 16,
  height: 22,
  color: Colors.dustyGray,
};

export const FormButton = {
  ...genericFontStyles,
  size: 12,
  height: 24,
  spacing: 3,
  weight: 500,
  color: Colors.boulder,
};


export const AssetListItem = {
  ...genericFontStyles,
  size: 36,
  height: 55,
  weight: 500,
  color: 'white',
};

export const AssetListItemNumber = {
  ...genericFontStyles,
  size: 30,
  height: 55,
  weight: 500,
  color: 'white',
};

export const AssetTopic = {
  ...genericFontStyles,
  size: 80,
  height: 86,
  family: 'Ogg-Regular',
  color: 'white',
};


export const AssetShareUrl = {
  ...AssetHeadline,
  height: 58,
  color: Colors.goldLight,
};

export const AssetHeadline = {
  ...genericFontStyles,
  size: 29,
  height: 69,
  weight: 500,
  spacing: 5.7,
  color: Colors.goldLight,
};

export const GenerateInfoText = {
  ...genericFontStyles,
  size: 14,
  height: 22,
};


export const GenerateHastag = {
  ...GenerateInfoText,
  color: Colors.goldLight,
};

export const DownloadButtonStyles = {
  ...genericFontStyles,
  size: 12,
  height: 12,
  spacing: 3,
  weight: 500,
};
